export { CoinbaseWalletConnector } from '@wagmi/core/connectors/coinbaseWallet';
